// src/api.js
import axios from "axios";
import { getAuth } from "./auth";

// Set REACT_APP_API_URL in the environment for any deployment other than local dev,
// pointing at wherever the backend ends up hosted.
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080",
});

// Automatically attach the logged-in admin's credentials (if any) to every request,
// so individual call sites don't each need to remember to do it. getAuth() returns
// {} when logged out, which is a no-op here.
API.interceptors.request.use((config) => ({
  ...config,
  ...getAuth(),
}));

export default API;
